import { render, staticRenderFns } from "./Index2.vue?vue&type=template&id=a68afa56&scoped=true&"
import script from "./Index2.vue?vue&type=script&lang=js&"
export * from "./Index2.vue?vue&type=script&lang=js&"
import style0 from "./Index2.vue?vue&type=style&index=0&id=a68afa56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a68afa56",
  null
  
)

component.options.__file = "Index2.vue"
export default component.exports